import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

// Component to protect routes that require admin privileges
const AdminRoute = ({ children }) => {
  const { user } = useSelector((state) => state.auth);

  // Check if user is logged in and has admin role
  if (!user) {
    // If no user is logged in, redirect to admin login page
    return <Navigate to="/admin/login" />;
  }

  // Handle different user object structures
  const userRole = user.role || user.user?.role;

  if (userRole !== "admin") {
    // If user is logged in but not admin, redirect to admin login
    return <Navigate to="/admin/login" />;
  }

  return children;
};

export default AdminRoute;
